<template>
    <div class="card" id="search" :class="{'searching' : searching}">
      <div class="row ml-0 align-items-center">
        <div class="">
          <i class="fa fa-search p-2 fa-lg" aria-hidden="true" @click="$emit('toggle')" />
        </div>
        <div class="col-10 px-0">
        <div class="row ml-0">
          <regular-input
            :value="input"
            @input="input = $event"
            type="text" :placeholder="$t('SearchBar.search')" class="col-6 my-2"/>
          <regular-select
          :value="criteria"
          @change="criteria = $event"
          :placeholder="$t('SearchBar.criteria')" class="col-6 pl-0 my-2">
            <option v-for="(criteria, key) in criterias" :value="key">{{criteria}}</option>
          </regular-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regularInput from '../../basic-components/regularInput.vue'
import regularSelect from '../../basic-components/regularSelect.vue'

export default {
  name: 'Search',
  components: {
    regularSelect,
    regularInput
  },
  props: {
    array: {
      type: Array,
      required: false
    },
    searching: {
      type: Boolean,
      required: false
    },
    criterias: {
      type: Object,
      required: false
    },
    reverse: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      input: '',
      criteria: '',
      searched: []
    }
  },
  methods: {
    match: function (regex) {
      return function (element) {
        regex = regex.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        var re = new RegExp(regex, 'i')
        return re.test(element)
      }
    },
    search: function (value) {
      if (value !== '') {
        const matcher = this.match(value)
        this.searched = this.array.filter(x => matcher(x[this.criteria]))
      } else {
        this.searched = this.array
      }
    }
  },
  mounted: function () {
    this.searched = this.array
    if (this.reverse) {
      var reverse = JSON.parse(JSON.stringify(this.searched))
      this.$emit('input', reverse.reverse())
    } else this.$emit('input', this.searched)
  },
  watch: {
    input: function (val) {
      if (this.criteria !== '') {
        this.search(val)
        if (this.reverse) {
          var reverse = JSON.parse(JSON.stringify(this.searched))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.searched)
      }
    },
    criteria: function (val) {
      if (this.input !== '') {
        this.search(this.input)
        if (this.reverse) {
          var reverse = JSON.parse(JSON.stringify(this.searched))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.searched)
      }
    },
    array: function () {
      if (this.input !== '' && this.criteria !== '') {
        this.search(this.input)
        if (this.reverse) {
          let reverse = JSON.parse(JSON.stringify(this.searched))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.searched)
      } else {
        if (this.reverse) {
          let reverse = JSON.parse(JSON.stringify(this.array))
          this.$emit('input', reverse.reverse())
        } else this.$emit('input', this.array)
      }
    }
  }
}
</script>

<style scoped>
  #search{
    position: fixed;
    right: -27.5rem;
    bottom: 1rem;
    /*height: 3rem;*/
    width: 30rem;
    background-color: #3f4244;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    transition: all 0.5s;
    overflow: hidden;
    border-left: 4px solid #f7941e;
  }
  .searching{
    right: -1.5rem !important;
    /*height: 8.5rem !important;*/
  }
  i{
    cursor: pointer;
    transition: all 0.2s;
    height: 100%;
    color: rgb(120, 120, 120);
  }
  i:hover{
    color: white;
  }
</style>
